import React from "react";
import Caption from "../components/Library/Caption";
import Embed from "../components/Library/Embed";
import Image from "../components/Library/Image";
import KeepReading from "../components/Library/KeepReading";
import Quote from "../components/Library/Quote";
import QuoteAttribution from "../components/Library/QuoteAttribution";
import styles from "../components/Library/StoryBody/StoryBody.css";

export default {
  "paragraph": React.createElement("p", { className: styles.paragraph }),
  "unstyled": React.createElement("p", { className: styles.paragraph }),
  "unordered-list-item": {
    element: React.createElement("li", { className: styles.item }),
    nest: React.createElement("ul", { className: styles.unorderedList })
  },
  "ordered-list-item": {
    element: React.createElement("li", { className: styles.item }),
    nest: React.createElement("ol", { className: styles.orderedList })
  },
  "styled-quote": React.createElement(Quote, { styled: true }),
  "plain-quote": React.createElement(Quote, { styled: false }),
  "quote-attribution": function quoteAttribution(block, extras) {
    return React.createElement(QuoteAttribution, { block: block, extras: extras });
  },
  "caption": React.createElement(Caption, null),
  "header-one": React.createElement("h1", null),
  // header-two needs to be h4 to nest correctly within heading structure for screen readers
  "header-two": React.createElement("h4", { className: styles.subhead }),
  "header-three": React.createElement("h3", null),
  "header-four": React.createElement("h4", null),
  "header-five": React.createElement("h5", null),
  "header-six": React.createElement("h6", null),
  "code-block": React.createElement("pre", null),
  "blockquote": React.createElement("blockquote", null),
  "media": React.createElement("figure", null),
  "image": function image(block) {
    return React.createElement(Image, { block: block });
  },
  "embed": function embed(block, extras, isClient) {
    return React.createElement(Embed, { block: block, isClient: isClient });
  },
  "keep-reading": function keepReading(block, extras) {
    return React.createElement(KeepReading, { block: block, extras: extras });
  },
  "default": React.createElement("p", { className: styles.paragraph, "data-unsupported": "true" })
};


// WEBPACK FOOTER //
// ./src/utils/blockHTML.js